export default {
  // Header
  "dc.header.badge": "Infraestructura Critica",
  "dc.header.back": "Regresar",
  "dc.header.active": "Infraestructura Activa",

  // Hero slides
  "dc.hero.slide1.tag": "Infraestructura Critica",
  "dc.hero.slide1.title": "Soluciones de Datacenter",
  "dc.hero.slide1.highlight": "e Infraestructura",
  "dc.hero.slide1.subtitle": "Diseno, implementacion y gestion de infraestructura de mision critica con estandares Tier III+, alta disponibilidad y redundancia N+1 para tu operacion.",
  "dc.hero.slide1.cta": "Ver capacidades",

  "dc.hero.slide2.tag": "Alta Disponibilidad",
  "dc.hero.slide2.title": "Redundancia N+1",
  "dc.hero.slide2.highlight": "Zero Downtime",
  "dc.hero.slide2.subtitle": "Arquitectura redundante en energia, refrigeracion y conectividad con UPS, generadores y enlaces de fibra dedicados para garantizar continuidad operativa 24/7/365.",
  "dc.hero.slide2.cta": "Conocer mas",

  "dc.hero.slide3.tag": "Seguridad Fisica",
  "dc.hero.slide3.title": "Proteccion Fisica",
  "dc.hero.slide3.highlight": "Multi-Capa",
  "dc.hero.slide3.subtitle": "Control de acceso biometrico, CCTV 24/7, monitoreo ambiental, deteccion y supresion de incendios, y personal de seguridad permanente para tu infraestructura.",
  "dc.hero.slide3.cta": "Ver seguridad",

  "dc.hero.viewSolutions": "Ver Soluciones",
  "dc.hero.backHome": "Volver al Inicio",

  // Features section
  "dc.features.tag": "Infraestructura",
  "dc.features.title": "Capacidades del",
  "dc.features.highlight": "Datacenter",
  "dc.features.subtitle": "Infraestructura de clase mundial con estandares enterprise, redundancia y seguridad certificada",

  "dc.features.f1.title": "Housing y Colocation",
  "dc.features.f1.desc": "Espacios dedicados en datacenters Tier III+ con racks privados, control de acceso biometrico y monitoreo ambiental continuo.",
  "dc.features.f1.stat": "Tier III+",
  "dc.features.f1.statLabel": "Certificacion",

  "dc.features.f2.title": "Energia Redundante",
  "dc.features.f2.desc": "Sistemas de UPS en paralelo N+1, generadores diesel con autonomia extendida y PDU inteligentes con medicion por circuito.",
  "dc.features.f2.stat": "99.995%",
  "dc.features.f2.statLabel": "Disponibilidad",

  "dc.features.f3.title": "Refrigeracion de Precision",
  "dc.features.f3.desc": "Sistemas de aire acondicionado de precision con pasillos frios/calientes, monitoreo termico y control de humedad en tiempo real.",
  "dc.features.f3.stat": "22 C",
  "dc.features.f3.statLabel": "Temp. optima",

  "dc.features.f4.title": "Conectividad Enterprise",
  "dc.features.f4.desc": "Enlaces de fibra dedicados, multiples carriers, BGP, redes SD-WAN y cross-connects para interconexion de baja latencia.",
  "dc.features.f4.stat": "+5",
  "dc.features.f4.statLabel": "Carriers",

  "dc.features.f5.title": "Seguridad Fisica",
  "dc.features.f5.desc": "Control de acceso biometrico multi-factor, CCTV con grabacion 24/7, mantrap, deteccion y supresion de incendios VESDA.",
  "dc.features.f5.stat": "24/7",
  "dc.features.f5.statLabel": "Vigilancia",

  "dc.features.f6.title": "Monitoreo y Gestion",
  "dc.features.f6.desc": "Plataforma DCIM centralizada con monitoreo de energia, temperatura, humedad y estado de equipos en tiempo real con alertas.",
  "dc.features.f6.stat": "< 1min",
  "dc.features.f6.statLabel": "Alerta",

  // Soluciones section
  "dc.solutions.tag": "Soluciones Enterprise",
  "dc.solutions.title": "Nuestras Soluciones de",
  "dc.solutions.highlight": "Data Center",
  "dc.solutions.subtitle": "Un ecosistema integral de servicios de infraestructura y tecnologia para impulsar la transformacion digital de tu organizacion",
  "dc.solutions.viewSolution": "Ver solucion",

  "dc.solutions.s1.title": "Data Center e Infraestructura",
  "dc.solutions.s1.subtitle": "Infraestructura de mision critica con estandares Tier III+, redundancia N+1 y monitoreo ambiental 24/7.",
  "dc.solutions.s2.title": "Servicios Cloud",
  "dc.solutions.s2.subtitle": "Migracion y gestion de entornos cloud hibridos con AWS, Azure y Google Cloud. Escalabilidad elastica.",
  "dc.solutions.s3.title": "Servicios de Seguridad",
  "dc.solutions.s3.subtitle": "Proteccion integral con firewalls NGFW, IDS/IPS, WAF, DLP y cifrado de datos en reposo y transito.",
  "dc.solutions.s4.title": "Redes y Comunicaciones",
  "dc.solutions.s4.subtitle": "Diseno de redes enterprise con SD-WAN, MPLS, fibra optica dedicada y balanceo de carga inteligente.",
  "dc.solutions.s5.title": "CiberSeguridad",
  "dc.solutions.s5.subtitle": "CyberSOC 24/7 con Threat Hunting, SIEM, SOAR y threat intelligence con mas de 200 especialistas.",
  "dc.solutions.s6.title": "Servicios Gestionados (SOC/NOC)",
  "dc.solutions.s6.subtitle": "Monitoreo proactivo 24/7/365 desde nuestro NOC y SOC con deteccion temprana y respuesta automatizada.",
  "dc.solutions.s7.title": "Bases de Datos y Resguardo",
  "dc.solutions.s7.subtitle": "Administracion Oracle, SQL Server, PostgreSQL. Backup, replica, alta disponibilidad y DR garantizado.",
  "dc.solutions.s8.title": "Continuidad del Negocio y Disaster Recovery",
  "dc.solutions.s8.subtitle": "Planes BCP/DRP con sitios alternos, replicacion sincronica y pruebas periodicas con RTO/RPO medibles.",
  "dc.solutions.s9.title": "Venta y renting de software/hardware",
  "dc.solutions.s9.subtitle": "Distribucion de licenciamiento enterprise, hardware de datacenter y soluciones integradas llave en mano.",
  "dc.solutions.s10.title": "Consultoria de Proyectos",
  "dc.solutions.s10.subtitle": "Servicios profesionales con metodologias agiles y PMI para diseno y ejecucion de proyectos IT.",

  // CTA
  "dc.cta.tag": "Activar Datacenter",
  "dc.cta.title": "Protege tu infraestructura con",
  "dc.cta.subtitle": "Infraestructura de clase mundial con disponibilidad garantizada, seguridad fisica 24/7 y soporte especializado",
  "dc.cta.button": "Solicitar evaluacion gratuita",
  "dc.cta.homeButton": "Ver sitio principal",
};